/**
* Created by elmer on 30/06/17.
*/
<template>
    <div>
        <h1>La página solicitada no existe</h1>
    </div>
</template>

<script>
  export default {};
</script>



// WEBPACK FOOTER //
// NotFoundComponent.vue?4ae6b9fb